module.exports = __webpack_public_path__ + "img/E.0143293e.svg";